import { Button } from '@components/Button/Button';

import classes from './Popup.module.scss';

type Props = {
	message: string;
	buttonLabel: string;
	onClose: () => void;
	// When both are provided the popup becomes a confirm/cancel dialog: buttonLabel/onClose act as
	// Cancel and confirmLabel/onConfirm as the primary Confirm action.
	confirmLabel?: string;
	onConfirm?: () => void;
};

export const Popup: React.FC<Props> = ({ message, buttonLabel, onClose, confirmLabel, onConfirm }) => {
	const isConfirm = confirmLabel !== undefined && onConfirm !== undefined;

	return (
		<div className={classes['overlay']}>
			<div className={classes['card']}>
				<p className={classes['message']}>{message}</p>
				{isConfirm ? (
					<div className={classes['buttonsRow']}>
						<Button fullWidth uppercase onClick={onClose} className={classes['cancelButton']}>
							{buttonLabel}
						</Button>
						<Button primary fullWidth uppercase onClick={onConfirm}>
							{confirmLabel}
						</Button>
					</div>
				) : (
					<Button primary fullWidth uppercase onClick={onClose}>
						{buttonLabel}
					</Button>
				)}
			</div>
		</div>
	);
};
